/**
 * ScandiPWA - Progressive Web App for Magento
 *
 * Copyright © Scandiweb, Inc. All rights reserved.
 * See LICENSE for license details.
 *
 * @license OSL-3.0 (Open Software License ("OSL") v. 3.0)
 * @package scandipwa/scandipwa-theme
 * @link https://github.com/scandipwa/scandipwa-theme
 */

import { Field } from '@tilework/opus';

import { ConfigQuery as SourceConfigQuery } from 'SourceQuery/Config.query';

/** @namespace Satisfly/Query/Config/Query */
export class ConfigQuery extends SourceConfigQuery {
    _getStoreConfigFields() {
        return [
            new Field('code'),
            new Field('is_active'),
            new Field('cms_home_page'),
            new Field('cms_no_route'),
            new Field('copyright'),
            new Field('timezone'),
            new Field('header_logo_src'),
            new Field('title_prefix'),
            new Field('title_suffix'),
            new Field('default_display_currency_code'),
            new Field('default_keywords'),
            new Field('default_title'),
            new Field('default_description'),
            new Field('default_country'),
            new Field('downloadable_links_target_new_window'),
            new Field('secure_base_media_url'),
            new Field('logo_alt'),
            new Field('logo_height'),
            new Field('logo_width'),
            new Field('cookie_text'),
            new Field('cookie_link'),
            new Field('terms_are_enabled'),
            new Field('address_lines_quantity'),
            new Field('base_url'),
            new Field('pagination_frame'),
            new Field('pagination_frame_skip'),
            new Field('anchor_text_for_previous'),
            new Field('anchor_text_for_next'),
            new Field('reviews_are_enabled'),
            new Field('reviews_allow_guest'),
            new Field('wishlist_general_active'),
            new Field('demo_notice'),
            new Field('guest_checkout'),
            new Field('is_email_confirmation_required'),
            new Field('display_product_stock_status'),
            new Field('base_link_url'),
            new Field('show_vat_number_on_storefront'),
            new Field('show_tax_vat_number'),
            new Field('product_use_categories'),
            new Field('category_url_suffix'),
            new Field('cookie_lifetime'),
            new Field('plp_list_mode'),
            new Field('layered_navigation_product_count_enabled'),
            new Field('region_display_all'),
            new Field('redirect_dashboard'),
            new Field('product_alert_allow_price'),
            new Field('product_alert_allow_stock'),
            new Field('newsletter_general_active'),
            new Field('newsletter_subscription_allow_guest_subscribe'),
            new Field('newsletter_subscription_confirm'),
            new Field('delivery_instore_active'),
            new Field('access_token_lifetime'),
            new Field('is_allowed_reorder'),
            new Field('rss_order_subscribe_allow'),
            new Field('downloadable_disable_guest_checkout'),
            new Field('minimun_password_length'),
            new Field('required_character_classes_number'),
            new Field('catalog_default_sort_by'),
            new Field('satisfly_dailyproductpromo_general_enable'),
            new Field('grid_per_page_values'),
            new Field('list_per_page_values'),
            new Field('grid_per_page'),
            new Field('list_per_page'),
            new Field('satisfly_cashondelivery_general_enable'),
            new Field('satisfly_cashondelivery_general_fee_value'),
            new Field('satisfly_bestsellers_general_category_id'),
            new Field('satisfly_bestsellers_general_category_url'),
            new Field('satisfly_strongpassword_general_enable'),
            new Field('satisfly_cashondelivery_general_fee_value'),
            new Field('satisfly_cashondelivery_general_enable'),
            new Field('amasty_mwishlist_general_enabled'),
            new Field('amasty_mwishlist_general_networks'),
            new Field('edrone_app_id'),
            ...this._getTimeDateFormatFields(),
            this._getPriceDisplayTypeField(),
            ...this.getBackordersFields(),
        ];
    }

    getBackordersFields() {
        return [
            'satisfly_backorders_modal_modal_message',
            'satisfly_backorders_modal_show_in_category',
            'satisfly_backorders_modal_show_in_product_page',
            'satisfly_backorders_modal_show_in_cart',
            'satisfly_backorders_modal_show_in_minicart',
            'satisfly_backorders_modal_show_in_checkout',
            'cataloginventory_item_options_backorders',
        ];
    }
}

export default new ConfigQuery();
